module.exports = __webpack_public_path__ + "band_11.064e848b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/parent_to_child/band_11.png
// module id = kLWE
// module chunks = 0